import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { actions as sharedActions } from "@shared/store";
import { actions } from "@containers/Sensor/store";
import { SensorListItem } from "@shared/models";
import { SensorForm } from "@containers/Sensor/components";
import { CreateSensorDto } from "@containers/Sensor/interfaces";
import { MODAL_TYPES, STATUS } from "@shared/constants";

interface SensorCreateEditContainerProps {
  onClose: () => void;
  sensor: SensorListItem | null;
}

const SensorCreateEditContainer = (props: SensorCreateEditContainerProps) => {
  const dispatch = useDispatch();
  const { onClose, sensor } = props;

  const changeStatus = useCallback(
    (id: number) => {
      if (!sensor) return;

      dispatch(
        sharedActions.showModal({
          type: MODAL_TYPES.CONFIRM,
          props: {
            heading: sensor.is_active ? "Deactivate" : "Activate",
            content: `Are you sure you want to ${sensor.is_active ? "deactivate" : "activate"} ${sensor.sensor_code}?`,
            cancelBtnText: "Cancel",
            successBtnText: sensor.is_active ? "Deactivate" : "Activate",
            onSuccess: () => {
              dispatch(
                actions.updateSensorStatus.request({
                  id,
                  status: sensor.is_active ? STATUS.INACTIVE : STATUS.ACTIVE,
                }),
              );

              onClose();
            },
          },
        }),
      );
    },
    [dispatch, onClose, sensor],
  );

  const changeFormValues = useCallback(() => {
    dispatch(sharedActions.updateOverlay({ leaveConfirm: true }));
  }, [dispatch]);

  const submitForm = useCallback(
    (payload: CreateSensorDto) => {
      dispatch(sharedActions.hideOverlay());

      if (!sensor) {
        dispatch(actions.createSensor.request(payload));
        return;
      }

      dispatch(actions.updateSensor.request({ ...payload, id: Number(sensor.id) }));
    },
    [dispatch, sensor],
  );

  return (
    <div className="user-create-edit-container">
      <SensorForm
        onChangeForm={changeFormValues}
        onCloseForm={onClose}
        onChangeStatus={changeStatus}
        onSubmitForm={submitForm}
        sensor={sensor}
      />
    </div>
  );
};

export default SensorCreateEditContainer;
